import { Component, Vue } from 'vue-property-decorator';
import { ITABLECOLCONF } from '@/types/base.d';
import api from '@/api/course';

@Component
export default class tableMixin extends Vue {
  private cList: any = [];

  public videoForm: any = {
    pid: '',
    stepId: '',
    videoId: '',
    videoTitle: '',
    sort: 0,
    userType: 1,
  }

  public chapterId: string = '';

  public chapterPid: string = '';

  private column: Array<ITABLECOLCONF> = [{
    label: '章节视频名称',
    prop: 'stepVideoTitle',
    align: 'center',
    width: '200px',
    tooltip: true,
  },
  {
    label: '视频名称',
    prop: 'videoTitle',
    align: 'center',
    width: '200px',
    tooltip: true,
  },
  {
    label: '视频描述',
    prop: 'videoDescription',
    align: 'center',
    width: '200px',
  },
  {
    label: '使用者',
    prop: 'userType',
    align: 'center',
    custom: true,
    width: '150px',
    tags: [{
      value: '1',
      type: 'info',
      label: '学生/老师',
    }, {
      value: '2',
      type: 'info',
      label: '老师',
    }],
  },
  {
    label: '排序',
    prop: 'seq',
    align: 'center',
    width: '60px',
  },
  {
    label: '创建时间',
    prop: 'createTime',
    align: 'center',
    minWidth: '80px',
    tooltip: true,
  }, {
    label: '操作',
    custom: true,
    minWidth: '120',
    align: 'center',
    maxBtn: 2,
    btnList: [
      // {
      //   title: '修改',
      //   name: '/course/chapter/video:update',
      //   icon: 'edit',
      //   type: 'info',
      //   callback: this.handleEdit,
      //   log: {
      //     name: '视频 - 修改',
      //     component: '/course/info:update',
      //   },
      // },
      {
        title: '修改',
        name: '/course/chapter/video:update',
        icon: 'edit',
        type: 'info',
        callback: this.handleEditVideo,
        log: {
          name: '视频 - 修改',
          component: '/course/chapter/video:update',
        },
      },
      {
        title: '删除',
        name: '/course/chapter/video:remove',
        icon: 'trash-o',
        type: 'info',
        callback: this.handleRemoveVideo,
        log: {
          name: '视频 - 删除',
          component: '/course/chapter/video:remove',
        },
      },
    ],
  }]

  private loading: boolean = false;

  getData(pid: string) {
    return new Promise((resolve, reject) => {
      api.getViideo(pid).then((res: any) => {
        this.cList = res;
        this.chapterId = pid;
        this.videoForm.stepId = pid;
        resolve(res);
      });
    });
  }

  /* eslint-disable class-methods-use-this */
  handleEdit(row: any) {}

  handleOperate(row: any) {}

  /**
   * @author liangyongmou
   * @desc 删除正式课事件
   * @params { any } row 行数据
   */
  handleRemoveVideo(row: any) {
    this.confirm('你确定要删除该视频吗?', {
      title: '警告',
      loading: true,
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      iconType: 'warning',
    }).then((close: Function) => {
      api.removeVideo(row.pid).then(() => {
        this.getData(this.chapterId);
        close();
        this.$log({
          title: '正式课管理 - 视频 - 确定',
          component: 'course/chapter/rescource',
        });
      }).catch(() => close());
    }).catch(() => this.$log({
      title: '正式课管理 - 视频 - 取消',
      component: 'course/chapter/rescource',
    }));
  }

  /* eslint-disable class-methods-use-this */
  handleEditVideo(row: any) {}
}
